import { render, staticRenderFns } from "./CreatePromotionModal.vue?vue&type=template&id=fa9a3e9a&scoped=true&"
import script from "./CreatePromotionModal.vue?vue&type=script&lang=js&"
export * from "./CreatePromotionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9a3e9a",
  null
  
)

export default component.exports